<template>
    <div class="progress" :style="{ height: `${height}rem` }">
        <div class="progress_bar" :style="{ background: `${backgroundColor}` }">
            <div class="progress_rate" :style="{ width: `${progress}` + '%', height: `${height}rem`, background: `${progressColor}` }"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'lineProgress',
    props: {
        height: {
            type: Number,
            default: 0.15
        },
        progress: {
            type: [Number, String],
            default: 0
        },
        backgroundColor: {
            type: String,
            default: 'var(--theme-progress-track, rgba(255, 255, 255, 0.20))'
        },
        progressColor: {
            type: String,
            default: 'var(--theme-progress-fill, linear-gradient(135deg, #FFFFFF 0%, #FF7824 100%))'
        }
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss">
    @import '@/common/styles/viriables.scss';
.progress {
    width: 100%;

    .progress_bar {
        width: 100%;
        height: 100%;
        border-radius: .2rem;
        position: relative;
        padding: .02rem;
        background: rgba(0, 0, 0, 0.20);
        overflow: hidden;
    }

    .progress_rate {
        position: absolute;
        top: 0;
        max-width: 100%;
        border-radius: .2rem;
        box-shadow: var(--theme-progress-shadow, 0 .08rem .2rem 0 #722400);
    }
}
</style>
